module.exports = __webpack_public_path__ + "img/MaschineRobot5.1fa82ddc.png";